import React, { useState } from "react";
import ContentContacts from "../atoms/ContentContacts";
import ContentLinks from "../atoms/ContentLinks";
import ContentDetails from "../atoms/ContentDetails";

export default function SegmentContent({
  item,
  title,
  contacts,
  links,
  detailContent,
}) {
  const [open, setOpen] = useState(false);
  const triggerId = `${item.id}_trigger`;

  return (
    <div
      className={`segment-column-content ${
        item.type === "idea" ||
        item.type === "note" ||
        (item.type === "transportation" && item.mode === "layover")
          ? "note"
          : "activity"
      }`}
    >
      <div className="segment-content-detail">
        <div className="segment-content-title">
          <span
            className={
              item.type === "idea" ||
              item.type === "note" ||
              (item.type === "transportation" && item.mode === "layover")
                ? "text-16"
                : "segment-title"
            }
          >
            {title}
          </span>

          {/* // display expand chevron */}
          {Boolean(detailContent) &&
            React.Children.count(detailContent) > 0 && (
              <button
                id={triggerId}
                className={`trigger no-print ${open ? "open" : ""}`}
                aria-expanded={open}
                aria-controls={`${item.id}_segment_detail`}
                onClick={() => setOpen((o) => !o)}
                title={open ? "Collapse" : "Expand"}
              />
            )}
        </div>

        <ContentContacts contacts={contacts} />
        <ContentLinks links={links} />

        <ContentDetails id={item.id} open={open}>
          {detailContent}
        </ContentDetails>
      </div>
    </div>
  );
}
